import axios from 'axios'

/* eslint-disable no-undef */
const req = new XMLHttpRequest()

req.open('GET', document.location, false)
req.send(null)
let headers = req.getAllResponseHeaders().toUpperCase()
headers = headers.split(/\n|\r|\r\n/g).reduce(function (a, b) {
  if (b.length) {
    var [key, value] = b.split(': ')
    a[key] = value
  }
  return a
}, {})

localStorage.setItem('headerDomain', headers['X-DDOL-ALIASORG'])
if (headers['X-DDOL-INST'] === 'DDOL' || !headers['X-DDOL-INST']) {
  localStorage.setItem('isOnPremise', 'no')
} else {
  localStorage.setItem('isOnPremise', 'yes')
}
const url = (document.location.host.split('-'))[0]
localStorage.setItem('urlCabecera', url)
//localStorage.setItem('urlCabecera', 'llopis') //Para probar en local

const HTTP = axios.create({
  //baseURL: (localStorage.getItem('isOnPremise') === 'yes' ? location.protocol + '//' + location.host : location.protocol + '//' + process.env.BASE_URL_WS_LOGIN)
  baseURL: (localStorage.getItem('isOnPremise') === 'yes' ? location.protocol + '//' + location.host : 'https://' + process.env.BASE_URL_WS_LOGIN) 
})

// Por si queremos hacer algo antes de ejecutar el request.
HTTP.interceptors.request.use(function (config) {
  if (localStorage.getItem('isOnPremise') === 'yes') {
    config.headers.common['x-ddol-security-token'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).tira : null
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

let showAlertaLogin = false

HTTP.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let messageResponse = '' + error
  if (!showAlertaLogin) {
    // El idioma lo ha de coger de la sesion !!!!!!
    if (messageResponse.indexOf('401') !== -1) {
      // Si no esta activo el token (ha caducado)
      this.$store.commit('removeAutenticacion')
      window.document.location = '/'
      showAlertaLogin = true
    }
  }
  return Promise.reject(error)
})

export default HTTP



// WEBPACK FOOTER //
// ./src/config/axios-config-login.js